import { Asset, BusinessCard } from '../api/backend'
import React, { useContext, useState } from 'react'

interface State {
  businessCard?: BusinessCard
  asset?: Asset
  setAsset: (asset: Asset) => void
}

const StateContext = React.createContext<State>({ businessCard: undefined, asset: undefined, setAsset: () => {} })

export const StateProvider: React.FC<Pick<State, 'businessCard'>> = ({ businessCard, children }) => {
  const [asset, setAsset] = useState<Asset>()
  return (
    <StateContext.Provider value={{ businessCard, asset, setAsset }}>
      {children}
    </StateContext.Provider>
  )
}

export const useLocalBusinessCard = () => useContext(StateContext).businessCard
export const usePreviewAsset = () => useContext(StateContext).asset
export const useSetPreviewAsset= () => useContext(StateContext).setAsset
